<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSupport_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6.588 1.139c-2.812.553-5.04 2.877-5.495 5.707-.527 3.277 1.242 6.214 3.945 7.482a1.244 1.244 0 0 0 2.489-.053 1.25 1.25 0 0 0-2.137-.88A6.03 6.03 0 0 1 2.345 10h1.082a5.04 5.04 0 0 0 1.927 2.227 2.23 2.23 0 0 1 2.766.76 5 5 0 0 0 4.454-2.988h1.334c.495 0 .913-.362.996-.85Q14.999 8.589 15 8a7.01 7.01 0 0 0-8.412-6.861M5.143 6.893a.893.893 0 1 1 1.786 0 .893.893 0 0 1-1.786 0m5.113 3.371c-.036.039-.89.965-2.256.965s-2.22-.925-2.256-.964a.501.501 0 0 1 .74-.673c.005.004.604.637 1.516.637s1.51-.633 1.517-.639a.501.501 0 0 1 .739.674m-.292-2.478a.893.893 0 1 1 0-1.787.893.893 0 0 1 0 1.787M12.899 7A5 5 0 0 0 3.1 7H2.08v-.002c.408-2.51 2.455-4.537 4.968-4.925A6.006 6.006 0 0 1 13.909 7z"
    />
</svg>
